<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.6875 6.38804C4.6875 4.90248 6.28021 3.96076 7.58187 4.67668L19.6033 11.2885C20.9525 12.0305 20.9525 13.9691 19.6033 14.7112L7.58187 21.323C6.2802 22.0389 4.6875 21.0972 4.6875 19.6116V6.38804Z" 
                :fill="color"
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgPlay',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>